import { lazy } from 'react';

const PnL = lazy(() => import(/* webpackChunkName: "PnL" */ './PnL'));

export { PnL };
